import React from 'react';
import styled from '@emotion/styled';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import store from '../../store';
import { useStaffCan } from '~Hooks';
import { useHistory, useRouteMatch } from 'react-router';
import State from '~Types/state';

const Wrapper = styled.div<{ noBg: boolean }>`
  height: 64px;
  width: 64px;
  position: fixed;
  left: 0;
  bottom: 0;
  background: ${({ noBg }) => (noBg ? 'transparent' : '#0e1216')};
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
`;

const MenuButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 24px;
`;

const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
  text-align: center;
`;

const Icon = styled.i`
  color: #fff;
  font-size: 24px;
  height: 24px;
  width: 24px;
  text-align: center;
  line-height: 24px;
`;

const CloseIcon = styled.i`
  color: #2f353d;
  line-height: 24px;
`;

type MainMenuButtonProps = {
  isShow: boolean;
  withoutLabel?: string;
  noBg?: boolean;
};

const MainMenuButton = ({ isShow, noBg = false }: MainMenuButtonProps) => {
  const staffCan = useStaffCan();
  const history = useHistory();
  const match = useRouteMatch();

  const toggleMenu = () => {
    if (!staffCan.openMainMenu) {
      history.push(`${match.url}/gateway`);
    } else {
      store.dispatch(actions.toggleMainMenu(!isShow));
    }
  };

  return (
    <Wrapper onClick={toggleMenu} noBg={noBg}>
      <MenuButtonWrapper>
        <IconWrapper>
          {!isShow ? (
            <Icon className="icon hamburger_wide" />
          ) : (
            <CloseIcon className="icon cross" />
          )}
        </IconWrapper>
      </MenuButtonWrapper>
    </Wrapper>
  );
};

const mapStateToProps = (state: State) => ({
  isShow: state.mainMenu,
  // menu is not used
  menu: state.POSMenu,
});

export default connect(mapStateToProps)(MainMenuButton);
